/* Recommendation click tracking (All Star Elite).
   Any click inside an element with data-rec-source="..." is recorded:
   1) the product link gets ?rec=<source> (visible in Clarity / analytics),
   2) a hidden cart attribute "_rec_clicks" lists source:handle pairs, so it is saved on the order.
   Fails silently — never blocks the click, add to cart or checkout. */
(function () {
  if (window.__aseRecTracking) return;
  window.__aseRecTracking = true;

  var KEY = "ase-rec-clicks";
  var MAX_AGE = 3 * 24 * 60 * 60 * 1000; // keep clicks for 3 days
  var MAX_ITEMS = 15;

  function handleFrom(href) {
    var m = (href || "").match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function load() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || "[]");
      var now = Date.now();
      return Array.isArray(list) ? list.filter(function (x) { return x && now - x.t < MAX_AGE; }) : [];
    } catch (e) { return []; }
  }

  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  document.addEventListener(
    "click",
    function (evt) {
      try {
        var box = evt.target.closest && evt.target.closest("[data-rec-source]");
        if (!box) return;
        var source = box.getAttribute("data-rec-source");
        var card = evt.target.closest(".product-card, .f-column") || box;
        var link = evt.target.closest('a[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
        if (!link) return;
        var handle = handleFrom(link.getAttribute("href"));
        if (!handle) return;

        // 1) tag the link (only links inside the row)
        if (evt.target.closest('a[href*="/products/"]')) {
          var url = new URL(link.href, window.location.origin);
          url.searchParams.set("rec", source);
          link.href = url.toString();
        }

        // 2) remember + save to cart as a hidden attribute
        var list = load().filter(function (x) { return !(x.s === source && x.h === handle); });
        list.unshift({ s: source, h: handle, t: Date.now() });
        list = list.slice(0, MAX_ITEMS);
        save(list);
        var value = list.map(function (x) { return x.s + ":" + x.h; }).join(",");
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
        fetch(root + "cart/update.js", {
          method: "POST",
          keepalive: true,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: { _rec_clicks: value } })
        }).catch(function () {});
      } catch (e) {}
    },
    true
  );
})();
